export const proofOfIncomePFTypes = [
  {
    label: "Estado de cuenta bancario",
    value: "bank_statement",
    description: "Completo, de débito (no crédito)",
  },
  {
    label: "Comprobante de nómina",
    value: "payroll_receipt",
    description: "Timbrado con sello del SAT",
  },
  {
    label: "Declaración de impuestos",
    value: "tax_declaration",
    description: "No acuse de recibo",
  },
];
export const proofOfIncomePMTypes = proofOfIncomePFTypes.filter(
  (type) => type.value !== "payroll_receipt",
);

export const proofOfIncomeTypesPMMap: any = {
  bank_statement: "Estado de cuenta bancario",
  tax_declaration: "Declaración de impuestos",
};
export const proofOfIncomeTypesPFMap: any = {
  ...proofOfIncomeTypesPMMap,
  payroll_receipt: "Comprobante de nómina",
};

export const labelProofOfIncomeOptions: any = {
  tenant: "inquilino",
  company: "la empresa",
  guarantor: "fiador/obligado solidario",
};
